import React, { createContext, useState } from "react";

export const TrfSearchContextAPI = createContext();

function TrfSearchContext({ children }) {
  const [trfDepartment, setTrfDepartment] = useState([]);
  const [trfLocation, setTrfLocation] = useState([]);
  const [processId, setProcessId] = useState([]);
  const [title, setTitle] = useState([]);
  const [businessType, setBusinessType] = useState([]);
  const [assignUnassign, setAssignUnassign] = useState([]);
  const [defaultDate, setDefaultDate] = useState(["", ""]);
  const [tatDate, setTatDate] = useState(["", ""]);
  const [currentInActive, setCurrentInActive] = useState(1);
  const [currentActive, setCurrentActive] = useState(1);
  const [activeCount, setActiveCount] = useState(0);
  const [inActiveCount, setInActiveCount] = useState(0);
  const [filterStatus, setFilterStatus] = useState(true);
  const [activeKey, setActiveKey] = useState("1");

  return (
    <TrfSearchContextAPI.Provider
      value={{
        trfDepartment,
        setTrfDepartment,
        trfLocation,
        setTrfLocation,
        processId,
        setProcessId,
        title,
        setTitle,
        businessType,
        setBusinessType,
        assignUnassign,
        setAssignUnassign,
        defaultDate,
        setDefaultDate,
        tatDate,
        setTatDate,
        currentActive,
        setCurrentActive,
        currentInActive,
        setCurrentInActive,
        filterStatus,
        setFilterStatus,
        activeKey,
        setActiveKey,
        activeCount,
        setActiveCount,
        inActiveCount, 
        setInActiveCount
      }}
    >
      {children}
    </TrfSearchContextAPI.Provider>
  );
}

export default TrfSearchContext;
